import type { PortableTextMarkComponentProps } from '@portabletext/react';

export const externalLinkGroq = /* groq */ `
{
    _type,
    action,
    button
}
`;

export function ActionButton({
    value,
    children,
}: PortableTextMarkComponentProps<{
    _type: 'actionButton';
    action?: string;
    button?: string;
}>) {
    return (
        <button
            disabled
            data-launch-chat
            className={value?.button === 'secondary-button' ? 'btn-secondary' : value?.button === 'primary-button' ? 'btn-primary' : undefined}
        >
            {children}
        </button>
    );
}
